import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "services/principal/customFetchBase";

export const modalidadCursoApi = createApi({
  reducerPath: "modalidadCursoApi",
  baseQuery: customFetchBase,
  tagTypes: ["ModalidadCurso"],
  endpoints: (builder) => ({
    getModalidadesCurso: builder.query({
      query: () => ({
        url: "/v1/api/modalidaddecurso/",
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "ModalidadCurso",
                id,
              })),
              { type: "ModalidadCurso", id: "LIST" },
            ]
          : [{ type: "ModalidadCurso", id: "LIST" }],
    }),
    getModalidadCurso: builder.query({
      query: (id) => ({
        url: `/v1/api/modalidaddecurso/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "ModalidadCurso", id }],
    }),
  }),
});

export const { useGetModalidadesCursoQuery, useGetModalidadCursoQuery } =
  modalidadCursoApi;
